<mat-toolbar color="primary">
  <button mat-icon-button (click)="toggleMenu.emit()" aria-label="Toggle menu">
    <mat-icon>menu</mat-icon>
  </button>

  <img src="/images/logos/kyloe-white.png" class="logo" alt="Kyloe" />
  <div class="badge-overflow" [matBadge]="stage !== 'prod' ? stage : ''">
    <h4>Connect Core</h4>
  </div>

  <span class="spacer"></span>

  <button mat-icon-button [matMenuTriggerFor]="userMenu" aria-label="User menu" class="avatar-btn">
    <img src="/images/logos/kyloe-icon-white.png" class="avatar-logo" alt="Menu" />
  </button>
</mat-toolbar>

<mat-menu #userMenu="matMenu" xPosition="before">
  <button mat-menu-item (click)="logout()">
    <mat-icon>logout</mat-icon>
    <span>Logout</span>
  </button>
</mat-menu>
